export default function Terms() {
  return <div>Terms</div>;
}
